<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Contratos del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <!--<v-btn
          color="info"
          dark
          class="ma-2"
          @click="$router.push('/admin/contratos/plantillas')"
          >Plantillas</v-btn
        >-->
        <v-spacer />

        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="contratos"
        :loading="loading"
        sort-by="ultimaFecha"
        sort-desc
      >
        <template v-slot:item.tipo="{ item }">
          {{ item.id }}
        </template>

        <template v-slot:item.estadoMostrar="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip small class="mr-2 pa-1 info" v-on="on"
                ><v-icon color="white">mdi-information</v-icon></v-chip
              >
            </template>
            <span>{{ item.estado }} </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.firmaGenerada ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-draw</v-icon></v-chip
              >
            </template>
            <span v-if="!item.firmaGenerada">No generada firma</span>
            <span v-else>Generada firma</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.enviadoEmail ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-email</v-icon></v-chip
              >
            </template>
            <span v-if="!item.enviadoEmail">No enviado por email</span>
            <span v-else>Enviado por email: {{ item.enviadoEmail }}</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-chip
                small
                class="mr-2 pa-1"
                :class="item.firmado ? 'success' : 'red'"
                v-on="on"
                ><v-icon color="white">mdi-check</v-icon></v-chip
              >
            </template>
            <span v-if="!item.firmado">No firmado</span>
            <span v-else>Firmado cliente</span>
          </v-tooltip>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                :color="item.visible ? 'success' : 'red'"
                min-width="0"
                v-on="on"
                :loading="item.loadingVisible"
                small
                @click="cambiarVisible(item)"
              >
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Visible para el cliente</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="px-2 ml-1"
                color="info"
                min-width="0"
                small
                v-on="on"
                @click="openDialogFicheros(item)"
              >
                <v-icon class="white--text" small>mdi-file-pdf</v-icon>
              </v-btn>
            </template>
            <span>Ficheros {{ item.nombre }}</span>
          </v-tooltip>
        </template>
      </v-data-table></base-material-card
    >

    <v-dialog v-model="dialogFicheros" max-width="600">
      <v-card class="mx-auto px-4">
        <v-row justify="center">
          <v-card-title class="mb-4">FICHEROS</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="f in modalItem.ficheros" :key="f.nombre">
                <v-list-item-title> {{ f.nombre }}</v-list-item-title
                ><v-list-item-action
                  ><v-icon @click="openFichero(f.url)" x-large color="primary"
                    >mdi-open-in-new</v-icon
                  ></v-list-item-action
                >
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda, idToTexto, mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      btnAccionesLoading: false,
      ficherosEnviar: [],
      emailsEnviar: [],
      modalItem: {},
      enviarFicherosDialog: false,
      dialogFicheros: false,
      dialogHistorial: false,
      generarDialog: false,
      generarEmails: [],
      generarLoading: false,
      generarItem: null,
      loading: false,
      loadingEliminar: false,
      dialog: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Cliente",
          value: "clienteMostrar",
        },
        {
          sortable: false,
          text: "Tipo",
          value: "tipo",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estadoMostrar",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    generarEmailsComputado: {
      get() {
        return this.generarEmails ? this.generarEmails.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.generarEmails = val.split(expresionRegular);
      },
    },
    historialComputed() {
      return this.modalItem.historial
        ? this.modalItem.historial
            .map((h) => {
              console.log(h);
              return {
                ...h,
                fechaMostrar: moment
                  .unix(h.fecha)
                  .format("DD-MM-YYYY HH:mm:ss"),
              };
            })
            .sort((a, b) => {
              return b.fecha - a.fecha - 1;
            })
        : [];
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      // contratos: (state) => state.contratos.contratos,
    }),
    contratos() {
      var contratos = this.$store.state.contratos.contratosRestaurante;
      var res = [];
      var firmaGenerada = false;
      var firmado = false;
      contratos.forEach((c) => {
        let historial = c.historial
          ? c.historial.sort((a, b) => {
              return b.fecha - a.fecha - 1;
            })
          : [];
        firmaGenerada = !!c.historial.find(
          (h) => h.accion == "cambio estado ready"
        );
        firmado = !!c.historial.find((h) => h.accion == "cambio estado signed");
        var foundGenerado = historial.find((h) => h.accion == "generado");
        var foundFirmado = historial.find((h) => h.accion == "firmado");
        var last =
          historial.length > 0 ? historial[historial.length - 1] : null;
        res.push({
          ...c,
          id: c.id,
          nombre: c.nombre,
          clienteMostrar: idToTexto(c.cliente),
          estadoMostrar: idToTexto(c.estado),
          fechaGenerado: foundGenerado ? foundGenerado.fecha : null,
          fechaGenerado: foundGenerado ? foundGenerado.fecha : null,
          ultimaFecha: last ? last.fecha : null,
          firmaGenerada: firmaGenerada,
          firmado: firmado,
        });
      });
      return res.sort((a, b) => {
        return b.ultimaFecha - a.ultimaFecha;
      });
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de contratos del restaurante";
    },
  },
  watch: {},
  methods: {
    openFichero(url) {
      window.open(url, "_blank");
    },
    openDialogHistorial(item) {
      this.modalItem = item;
      this.dialogHistorial = true;
    },
    openDialogFicheros(item) {
      this.modalItem = item;
      this.dialogFicheros = true;
    },
    goPdf(item) {
      this.$store.dispatch("contratos/generarPdf", item.id);
    },
    reload() {
      let _vm = this;
      _vm.loading = true;
      this.$store
        .dispatch("contratos/getContratosRestaurante")
        .then(() => {})
        .catch((e) => {
          console.log(e);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se han podido cargar los contratos",
          });
        })
        .finally(() => (_vm.loading = false));
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style>
</style>